"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isCellJson = void 0;
const isObject_1 = require("./isObject");
const TileJson_1 = require("./TileJson");
const isCellJson = (value) => {
    return ((0, isObject_1.isObject)(value) &&
        typeof value.isEmpty === 'boolean' &&
        ((0, TileJson_1.isTileJson)(value.tile) || value.tile === null) &&
        typeof value.x === 'number' &&
        typeof value.y === 'number');
};
exports.isCellJson = isCellJson;
